/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 * 
 **/
import { createIcon } from "@v2/helpers/icons/create-icon";
export const MonIcon = createIcon({
  displayName: "MonIcon",
  viewBox: "0 0 16 16",
  path: (<g fill="none"><path d="M3.20508 3.54492H4.93626L7.9462 10.8944H8.057L11.0669 3.54492H12.7981V12.9995H11.4409V6.15785H11.3532L8.56481 12.9856H7.43839L4.65004 6.15323H4.56232V12.9995H3.20508V3.54492Z" fill="currentColor" /></g>)
});